import * as React from 'react';
import { Link } from 'react-router-dom';
import { authenticationService } from '../../webportal/services/authentication';
import { LogoutIcon, renderLucidLinkLogo } from '../../webportal/components/common/Icons';
import { injectProfile, ProfileInjectorProperties } from '../../webportal/components/hocs/ProfileInjector';
import { Search, SearchType } from './common/Search';

interface BackOfficeTopBarProps extends ProfileInjectorProperties  {
    onSearchClick: (searchValue: string, searchType: SearchType) => void;
    resultsLength?: number;
    searchValue?: string;
    isSearchInitial?: boolean;
    searchType: SearchType;
    securityScopes?: string [];

}

interface BackOfficeTopBarState {

}

class BackOfficeTopBar extends React.Component<BackOfficeTopBarProps, BackOfficeTopBarState> {
    constructor(props: BackOfficeTopBarProps) {
        super(props);
    }

    render() {
        return (
            <header className="pageHeader">
                <div className="row">
                    {this.props.isSearchInitial &&
                    <React.Fragment>
                        <div className="col-3">&nbsp;</div>
                        <div className="col-6 margin center">
                            <a href="index.html">
                                {renderLucidLinkLogo('60px', '51px')}
                            </a>
                        </div>
                    </React.Fragment>}
                    {!this.props.isSearchInitial &&
                    <React.Fragment>
                        <div className="col-1 margin">
                        <a href="index.html#!watch">
                            {renderLucidLinkLogo()}
                        </a>
                    </div>
                        <div className="col-8">
                        <Search
                            searchValue={this.props.searchValue}
                            onSearchClick={this.props.onSearchClick}
                        />
                        <h1>
                    {this.renderSearchResultsLength()}
                        </h1>
                        </div>
                    </React.Fragment>
                    }
                    <div className="col-3 margin">
                        <div className="row right vcenter">
                            <div className="info left">
                                Hello, {this.props.attributes.firstName}<br/>
                                <span>{this.props.email}</span>
                            </div>
                            <Link
                                to={'#'}
                                className="logout"
                                onClick={authenticationService.signOut}
                            >
                                <LogoutIcon width="18px" height="18px"/>
                            </Link>
                        </div>
                    </div>
                </div>
            </header>
        );
    }

    private renderSearchResultsLength(): JSX.Element | null {
        if (this.props.searchValue && this.props.resultsLength) {
            return <> Search by {this.props.searchType}: <strong>{this.props.searchValue} ({this.props.resultsLength} results)</strong></>;
        }
        if (this.props.searchType) {
            return (
                <>Search by {this.props.searchType}: <strong>{this.props.searchValue} (0
                results)</strong></>
            );
        }
        return null;
    }
}

export default injectProfile(BackOfficeTopBar) as any;


// WEBPACK FOOTER //
// ./src/backoffice/components/TopBar.tsx